import React, { useEffect } from "react";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { useState } from "react";
import TextEditor from "../TextEditor/TextEditor";
import axios from "axios";
import { Url } from "../../config/config";
import { toast } from "react-toastify";
import useButtonLoader from "../../hooks/useButtonLoader";

const TabPanel = ({ title, type }) => {
  const [page, setPage] = useState({
    type: type,
    description: EditorState.createEmpty(),
  });

  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );

  //***************Get page content************** */
  const getContent = async () => {
    try {
      const res = await axios({
        url: `${Url}/socail/content_details?type=${type}`,
        method: "GET",
      });
      if (res.status === 200) {
        setPage({
          type: res.data.data.cms.type,
          description: EditorState.createWithContent(
            ContentState.createFromBlockArray(
              convertFromHTML(res.data.data.cms.description)
            )
          ),
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  //   update page content
  const updatePageContent = async () => {
    try {
      setSubmitLoading(true);
      const finalPageContent = {
        type: page.type,
        description: draftToHtml(
          convertToRaw(page.description.getCurrentContent())
        ),
      };
      const res = await axios({
        url: `${Url}/socail/update_content`,
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: finalPageContent,
      });
      setSubmitLoading(false);
      if (res.data.status === 200) {
        toast.success(res.data.message);
        getContent();
      } else if (res.data.status === 419) {
        toast.error(res.data.message);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getContent();
  }, [type]);

  return (
    <div className="mt-4 text-center">
      <h4 className="text-center">{title}</h4>
      <TextEditor
        editorState={page}
        setEditorState={(value) => setPage(value)}
      />
      <button
        ref={submitButtonElement}
        className="button mt-3"
        onClick={updatePageContent}
      >
        Save
      </button>
    </div>
  );
};

export default TabPanel;
